module.exports = __webpack_public_path__ + "static/chic-b6b41709c037af08e1b174b01baae178.png";